import { useEffect } from 'react';
import usePrevious from '@sift/resift/usePrevious';
import { useSnackbar } from 'notistack';
import getIsLoading from 'helpers/getIsLoading';
import getHasError from 'helpers/getHasError';

interface Args {
  status: any;
  successMessage?: string;
  errorMessage?: string;
}

function useFormSnackbar({
  status,
  successMessage = 'Settings have been updated.',
  errorMessage = 'There was an error submitting your changes. Please try again.',
}: Args) {
  const { enqueueSnackbar } = useSnackbar();
  const prevStatus = usePrevious(status);

  useEffect(() => {
    if (getIsLoading(prevStatus) && !getIsLoading(status)) {
      if (getHasError(status)) {
        enqueueSnackbar(errorMessage, {
          variant: 'error',
        });
      } else {
        enqueueSnackbar(successMessage, { variant: 'success' });
      }
    }
  }, [status, prevStatus]);
}

export default useFormSnackbar;
